import { Model } from "@vuex-orm/core";
import config from "../configs/Recipient";

export default class Recipient extends Model {
  static get entity() {
    return "recipients";
  }
  static fields() {
    return {
      id: this.attr(null),
      building_owner_id: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      gender: this.attr(null),
      email: this.attr(null),
      address: this.attr(null),
      complement: this.attr(null),
      complement2: this.attr(null),
      zipcode: this.attr(null),
      city: this.attr(null),
      country: this.attr(null),
      contact_type: this.attr(null),
      agency_id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
      building_id: this.attr(null),
      agency_preferred_broadcast: this.attr(null),
      agency_preferred_invitation_broadcast: this.attr(null),
      docs_status: this.attr(null),
      doc_requests: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
